import * as React from 'react';
import createSvgIcon from './createSvgIcon';
/**
 * @ignore - internal component.
 */

export default createSvgIcon(React.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js
// module id = 1210
// module chunks = 0